import { render } from "./FailurePayment.vue?vue&type=template&id=8aaec13a"
import script from "./FailurePayment.vue?vue&type=script&lang=js"
export * from "./FailurePayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__